
import messagesAPI from '@/api/messagesAPI'

export const messagesStore = {
    // This makes your getters, mutations, and actions accessed by, eg: 'userStore/{name}' instead of mounting getters, mutations, and actions to the root namespace.
    namespaced: true,

    state: {
        conversations: [],
        conversations_synced : 0,
        conversation_messages : {}
    },


    getters: {

    },


  actions: {
      
        async getConversationAttachments({ commit, state }, { conversation_id }) {
            if(!conversation_id) return 0
            const response = await messagesAPI.getConversationAttachments({ conversation_id })
            if (response && response.data) {
              commit('SET_CONVERSATION_ATTACHMENTS', {
                conversation_id,
                attachments: response.data
              })
            }
        },

        async archiveConversation({ commit, state }, { conversation_id }) {

            const response = await messagesAPI.archiveConversation({
                conversation_id : conversation_id
            })

            commit('REMOVE_CONVERSATION', {
                conversation_id : conversation_id
            })

            return response
        },


        /**
         * Function for creating a new conversation
         */
        async createNewConversation({ commit, state }, { title, groups, members }) {

            const response = await messagesAPI.createNewConversation({
                title : title,
                groups : groups,
                members : members
            })

            commit('ADD_NEW_CONVERSATION', {
                conversation : response.data
            })

            return response
        },

        /**
         * Function for updating conversation
         */
        async updateConversation({ commit, state }, { id, title, groups, members, talk_room_id }) {
            const data = {
                  id: id,
                  title : title,
                  groups : groups,
                  members: members,
            }
            if(talk_room_id) data.talk_room_id = talk_room_id
            const response = await messagesAPI.updateConversation(data)

            commit('REPLACE_CONVERSATION', {
                conversation : response.data
            })

            return response
        },

        /**
         * Function for getting all group folders
         */
        async getConversationMessages({ commit, state }, { conversation_id }) {

            // if (state.conversation_messages[conversation_id] && state.conversation_messages[conversation_id].length) {
            //     return state.conversation_messages[conversation_id]
            // } else {
            const response = await messagesAPI.getConversationMessages({
                conversation_id : conversation_id
            })
            commit('SET_CONVERSATION_MESSAGES', {
                conversation_id : conversation_id,
                messages : response.data
            })
            return response
            // }
        },

        /**
         * Function for getting all conversations
         */
        async getConversations({ commit, state }) {

            // if (state.conversations_synced) {
            //     return state.conversations
            // } else {
            const response = await messagesAPI.getConversations()
            commit('SET_CONVERSATIONS', {
                conversations : response.data
            })
            return response
            // }
        },

        /**
         * Function for getting all group folders
         */
        async markConversationSeen({ commit, state }, { conversation_id }) {

            const response = await messagesAPI.markConversationRead({
                conversation_id : conversation_id
            })

            commit('SET_CONVERSATION_SEEN', {
                conversation_id : conversation_id
            })

            return response
        },

        async markConversationUnseen({ commit, state }, { conversation_id }) {

            const response = await messagesAPI.markConversationUnread({
                conversation_id : conversation_id
            })

            commit('SET_CONVERSATION_UNSEEN', {
                conversation_id : conversation_id
            })

            return response
        },

        async registerNewMessage({ commit, state }, { conversation_id, message_data, conversation_data }) {

            if (state.conversation_messages[conversation_id] && state.conversation_messages[conversation_id].length) {
                commit('SET_CONVERSATION_UNSEEN', { conversation_id : conversation_id })
                commit('ADD_NEW_MESSAGE', { conversation_id : conversation_id, message_data : message_data })
            } else {
                commit('ADD_NEW_CONVERSATION', { conversation : conversation_data })
            }
            return 1
        },

        async sendNewMessage({ commit, dispatch, state }, { conversation_id, message_data, fetch_conversation_attachments = false, update_conversations = false }) {

            const response = await messagesAPI.sendNewMessage({
                conversation_id : conversation_id,
                message_data : message_data
            })

            const new_message_data = response.data
            commit('ADD_NEW_MESSAGE', {
                conversation_id : conversation_id,
                message_data : new_message_data
            })
            commit('UPDATE_CONVERSATION_LAST_MESSAGE', { message: new_message_data })

            commit('PURGE_SEEN_BY_FOR_CONVERSATION', {
                conversation_id : conversation_id
            })
          
            if (fetch_conversation_attachments && message_data.attachments && message_data.attachments.length) {
                dispatch('getConversationAttachments',{conversation_id})
            }
            return new_message_data

        },

        async removeMessage({commit, dispatch, state}, {conversation_id, message_id, delete_completely = true, fetch_conversation_attachments=false}) {
            const response = await messagesAPI.removeMessage({
                conversation_id,
                message_id
            })
          const messages = state.conversation_messages[conversation_id]
          if (messages) {
            const message = messages.find(item => parseInt(item.message_id) === parseInt(message_id))
            if (message && message.attachments && message.attachments.length) {
                if (fetch_conversation_attachments) {
                    dispatch('getConversationAttachments',{conversation_id})
                }
            }
          }
          commit('REMOVE_MESSAGE', {
            conversation_id,
            message_id,
            delete_completely,
            message: response.data
          })
        },

        /**
         * Soft-delete several messages at once.
         *
         * The server blanks each message rather than dropping the row, so the
         * stream keeps its "This message was deleted" placeholders — same as
         * the single-message delete with delete_completely: false.
         */
        async removeMessages({commit, dispatch, state}, {conversation_id, message_ids, delete_completely = false, fetch_conversation_attachments = false}) {
            if (!conversation_id || !message_ids || !message_ids.length) return 0

            const response = await messagesAPI.removeMessages({
                conversation_id,
                message_ids
            })

            const deleted_messages = (response.data && response.data.messages) || []

            commit('REMOVE_MESSAGES', {
                conversation_id,
                delete_completely,
                messages: deleted_messages
            })

            if (fetch_conversation_attachments) {
                dispatch('getConversationAttachments', { conversation_id })
            }

            return response.data
        },

        /**
         * Archive conversations for the current user.
         *
         * Drops them from the list exactly like the single-conversation
         * archiveConversation action does; a new message brings them back on
         * the next fetch.
         */
        async archiveConversations({ commit, state }, { conversation_ids }) {
            if (!conversation_ids || !conversation_ids.length) return 0

            const response = await messagesAPI.archiveConversations({
                conversation_ids
            })

            const archived = (response.data && response.data.archived) || []

            commit('REMOVE_CONVERSATIONS', {
                conversation_ids : archived
            })

            return response.data
        },

        /**
         * Soft-delete conversations for the current user.
         *
         * Only ids the server actually deleted are dropped from the list, so a
         * stale selection cannot make a conversation disappear client-side
         * while it is still there on reload.
         */
        async removeConversations({ commit, state }, { conversation_ids }) {
            if (!conversation_ids || !conversation_ids.length) return 0

            const response = await messagesAPI.removeConversations({
                conversation_ids
            })

            const deleted = (response.data && response.data.deleted) || []

            commit('REMOVE_CONVERSATIONS', {
                conversation_ids : deleted
            })

            return response.data
        },

        async removeConversationMember({ commit, state }, { conversation_id, user_id }) {
            const response = await messagesAPI.removeConversationMember({
                conversation_id : conversation_id,
                user_id : user_id
            })

            commit('REMOVE_CONVERSATION_MEMBER', {
                conversation_id : conversation_id,
                user_id : user_id,   
            })

            return response
        },


        // Update message
        async updateMessage({ commit, state }, { conversation_id, message_id, message_data, fetch_conversation_attachments=false }) {
            const response = await messagesAPI.updateMessage({
                conversation_id,
                message_id,
                message_data
            })

            const updated_message = response.data

            commit('UPDATE_MESSAGE', {
                conversation_id,
                message_id,
                updated_message,
            })
          if (fetch_conversation_attachments && message_data.attachments && message_data.attachments.length) {
                dispatch('getConversationAttachments',{conversation_id})
            }

            return updated_message
        },


    },


    mutations: {
        UPDATE_CONVERSATION_LAST_MESSAGE: (state, { message }) => {
            if(!message) return 0
            const index = state.conversations.findIndex(conversation => conversation.conversation_id === message.conversation_id)
            if (index !== -1) {
                state.conversations[index] = {...state.conversations[index], ...{latest_message: message}}
            }
        },
        ADD_NEW_CONVERSATION: (state, { conversation }) => {

            state.conversation_messages[conversation.conversation_id] = []
            state.conversations.push(conversation)

        },
        SET_CONVERSATION_ATTACHMENTS: (state, { conversation_id, attachments }) => { 
          const index = state.conversations.findIndex(conversation => parseInt(conversation.conversation_id) === parseInt(conversation_id))
          if (index !== -1) {
            const conversation = state.conversations[index]
            conversation.attachments = attachments
            state.conversations[index] = conversation
          }
        },

        REPLACE_CONVERSATION: (state, { conversation }) => {

            let index = null
            for (let i = 0; i < state.conversations.length; i++) {
                if (conversation.id === state.conversations[i].id) {
                    index = i
                    break
                }
            }

            if (index !== null) {
                state.conversations.splice(index, 1)
            }

            state.conversations.push(conversation)

        },

        ADD_NEW_MESSAGE: (state, { conversation_id, message_data }) => {
            if (!state.conversation_messages[conversation_id] && !state.conversation_messages[conversation_id].length) {
                state.conversation_messages[conversation_id] = []
            }

            state.conversation_messages[conversation_id].push(message_data)

        },

        PURGE_SEEN_BY_FOR_CONVERSATION: (state, { conversation_id }) => {
            if (state.conversations && state.conversations.length) {
                state.conversations.map( (conversation, index) => {
                    if (parseInt(conversation.conversation_id) === parseInt(conversation_id)) {
                        if (conversation.members && conversation.members.length) {
                            conversation.members.map( (member, index) => {
                                conversation.members[index].conversation_read = 0
                            })
                        }
                    }
                })
            }
        },

        REMOVE_CONVERSATION: (state, { conversation_id }) => {
            if (state.conversations && state.conversations.length) {
                state.conversations.map( (conversation, index) => {
                    if (parseInt(conversation.conversation_id) === parseInt(conversation_id)) {
                        state.conversations.splice(index, 1)
                    }
                })
            }
        },

        REMOVE_CONVERSATIONS: (state, { conversation_ids }) => {
            if (!state.conversations || !state.conversations.length) return
            if (!conversation_ids || !conversation_ids.length) return

            const removed = conversation_ids.map(id => parseInt(id))

            state.conversations = state.conversations.filter(conversation => (
                !removed.includes(parseInt(conversation.conversation_id))
            ))

            removed.forEach(id => {
                delete state.conversation_messages[id]
            })
        },

        REMOVE_CONVERSATION_MEMBER: (state, {conversation_id, user_id}) => {
            if (state.conversations && state.conversations.length) {
                state.conversations.map( (conversation, index) => {
                    if (parseInt(conversation.conversation_id) === parseInt(conversation_id)) {
                        if (conversation.members && conversation.members.length) {
                            conversation.members.map( (member, index) => {
                                if (parseInt(member.user_id) === parseInt(user_id)) {
                                    conversation.members.splice(index, 1)
                                }
                            })       
                        }
                    }
                })
            }
        },

        SET_CONVERSATION_MESSAGES: (state, { conversation_id, messages }) => {
            state.conversation_messages[conversation_id] = messages
        },

        SET_CONVERSATIONS: (state, { conversations }) => {
            state.conversations = conversations
            state.conversations_synced = 1
        },

        SET_CONVERSATION_SEEN: (state, { conversation_id }) => {
            for (let conversation of state.conversations) {
                if (parseInt(conversation.conversation_id) === parseInt(conversation_id)) {
                    let index = state.conversations.indexOf(conversation)
                    let time = new Date().getTime()
                    state.conversations[index].conversation_read = time
                    break
                }
            }

        },
        SET_CONVERSATION_UNSEEN: (state, { conversation_id }) => {
            for (let conversation of state.conversations) {
                if (parseInt(conversation.conversation_id) === parseInt(conversation_id)) {
                    let index = state.conversations.indexOf(conversation)
                    state.conversations[index].conversation_read = 0
                    break
                }
            }

        },

        // Update message
        // A realtime event can name a conversation this tab hasn't loaded: nothing to update then.
        UPDATE_MESSAGE: (state, { conversation_id, message_id, updated_message}) => {
          if (!state.conversation_messages[conversation_id]) return
          // Find message index
          const index = state.conversation_messages[conversation_id].findIndex(message => (
            message.message_id === message_id
          ))
          if (index === -1) return

          // Set updated message
          state.conversation_messages[conversation_id][index] = updated_message
        },

        REMOVE_MESSAGE: (state, { conversation_id, message_id, delete_completely, message}) => {
            conversation_id = +conversation_id
            message_id = +message_id
            if (!state.conversation_messages[conversation_id]) return
            // Find message index
            const index = state.conversation_messages[conversation_id].findIndex(message => (
                +message.message_id === message_id
            ))

          if (index !== -1) {
                if (delete_completely) {
                  state.conversation_messages[conversation_id].splice(index, 1)
                } else {
                  state.conversation_messages[conversation_id][index] = message
                }
                
            }
        },
        REMOVE_MESSAGES: (state, { conversation_id, delete_completely, messages }) => {
            conversation_id = +conversation_id
            const stream = state.conversation_messages[conversation_id]
            if (!stream || !messages || !messages.length) return

            messages.forEach(message => {
                const index = stream.findIndex(item => +item.message_id === +message.message_id)
                if (index === -1) return

                if (delete_completely) {
                    stream.splice(index, 1)
                } else {
                    stream[index] = message
                }
            })
        },

        MARK_MESSAGE_AS_DELETED: (state, { message_id, conversation_id }) => {
            if (!state.conversation_messages[conversation_id]) return
            const index = state.conversation_messages[conversation_id].findIndex(message => (
                parseInt(message.message_id) === parseInt(message_id)
            ))
            if (index !== -1) {
              const message = state.conversation_messages[conversation_id][index]
              state.conversation_messages[conversation_id][index] = { ...message, ...{ deleted: '1', message_text: '', attachments: [], reply_to_message_id: '0' } }
            }
        }

    }
}
